const GallaryApi = [
    "https://images-assets.nasa.gov/image/iss065e152560/iss065e152560~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e154254/iss065e154254~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210625-PH-KLS01_0050/KSC-20210625-PH-KLS01_0050~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e154219/iss065e154219~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e154205/iss065e154205~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e154164/iss065e154164~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210625-PH-KLS01_0068/KSC-20210625-PH-KLS01_0068~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210618-PH-PPC01_0009/KSC-20210618-PH-PPC01_0009~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e154183/iss065e154183~thumb.jpg",
    "https://images-assets.nasa.gov/image/MSFC-202100163/MSFC-202100163~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210614-PH-RNB01_0055/KSC-20210614-PH-RNB01_0055~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e148960/iss065e148960~thumb.jpg",
    "https://images-assets.nasa.gov/image/MSFC-202100169/MSFC-202100169~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210621-PH-PPC01_0083/KSC-20210621-PH-PPC01_0083~thumb.jpg",
    "https://images-assets.nasa.gov/image/MSFC-201900254/MSFC-201900254~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210617-PH-PPC01_0028/KSC-20210617-PH-PPC01_0028~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210614-PH-RNB01_0041/KSC-20210614-PH-RNB01_0041~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210618-PH-PPC01_0071/KSC-20210618-PH-PPC01_0071~thumb.jpg",
    "https://images-assets.nasa.gov/image/MSFC-202100131/MSFC-202100131~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210611-PH-KLS02_0025/KSC-20210611-PH-KLS02_0025~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210621-PH-PPC01_0034/KSC-20210621-PH-PPC01_0034~thumb.jpg",
    "https://images-assets.nasa.gov/image/MSFC-202100137/MSFC-202100137~thumb.jpg",
    "https://images-assets.nasa.gov/image/MSFC-202100182/MSFC-202100182~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e144867/iss065e144867~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e145380/iss065e145380~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210624-PH-KLS01_0088/KSC-20210624-PH-KLS01_0088~thumb.jpg",
    "https://images-assets.nasa.gov/image/MAF20210116_GR0006/MAF20210116_GR0006~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e145170/iss065e145170~thumb.jpg"
]


const Galaryshort =[
    "https://images-assets.nasa.gov/image/iss065e154213/iss065e154213~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e154254/iss065e154254~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e154164/iss065e154164~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e148960/iss065e148960~thumb.jpg",
    "https://images-assets.nasa.gov/image/MSFC-202100163/MSFC-202100163~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210621-PH-PPC01_0083/KSC-20210621-PH-PPC01_0083~thumb.jpg",
    "https://images-assets.nasa.gov/image/KSC-20210611-PH-KLS02_0025/KSC-20210611-PH-KLS02_0025~thumb.jpg",
    "https://images-assets.nasa.gov/image/iss065e129913/iss065e129913~thumb.jpg"
]

export {GallaryApi , Galaryshort}